var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.webstoreContent
    ? _c(
        "div",
        { attrs: { id: "product-page" } },
        [
          _c("ProductSubNav", {
            attrs: {
              globals: _vm.webstoreContent.webstoreBody,
              productContent: _vm.content,
              isSticky: _vm.productNavIsSticky,
            },
            on: {
              clicked: _vm.setTab,
              "change-active-page": _vm.changeActivePage,
            },
          }),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.activeProductTab === "overview"
                ? _c("ProductOverviewTab", {
                    attrs: { content: _vm.content },
                    on: { clicked: _vm.setTab },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.activeProductTab === "features"
                ? _c(
                    "ProductFeatureTab",
                    {
                      key: "features",
                      staticClass: "roboto",
                      attrs: {
                        product: _vm.content.features,
                        globals: _vm.webstoreContent.webstoreBody,
                        length: _vm.featureLength,
                        title: _vm.content.featuresHeader,
                        group: _vm.content.features,
                        activeProduct: _vm.activeProductInfo,
                      },
                    },
                    [
                      _vm.webstoreContent.webstoreBody.license &&
                      _vm.activeProductKey.includes("CM")
                        ? _c("LicenseModule", {
                            staticClass: "roboto",
                            attrs: {
                              content: _vm.webstoreContent.webstoreBody.license,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.activeProductTab === "specs"
                ? _c("ProductFeatureTab", {
                    key: "specs",
                    staticClass: "roboto",
                    attrs: {
                      product: _vm.content.specs,
                      globals: _vm.webstoreContent.webstoreBody,
                      length: _vm.specLength,
                      specs: true,
                      title: _vm.content.specsHeader,
                      group: _vm.content.specs,
                      activeProduct: _vm.activeProductInfo,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "fade" } },
            [
              _vm.activeProductTab === "buy"
                ? _c("AddToCartTab", {
                    ref: "addToCart",
                    attrs: {
                      submitButtonText: _vm.submitButtonText,
                      addToCartDisabled: _vm.addToCartDisabled,
                      bottomNavIsShown: _vm.bottomNavIsShown,
                    },
                    on: {
                      "add-to-cart": function ($event) {
                        return _vm.cartUpdateHandler($event)
                      },
                      "handle-scroll": _vm.handleScroll,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c("CMModal", {
            attrs: {
              isOpen: _vm.isModalVisible,
              globals: _vm.webstoreContent.webstoreBody,
              showCM31: _vm.showCM31,
              showCM32: _vm.showCM32,
            },
            on: {
              "cm-add-to-cart": _vm.cmAddToCart,
              "hide-modal": function ($event) {
                return _vm.hideModal()
              },
            },
          }),
          _vm._v(" "),
          _c("InquireModal", {
            attrs: { isOpen: _vm.inquireModalIsOpen },
            on: {
              "hide-modal": function ($event) {
                _vm.inquireModalIsOpen = false
              },
            },
          }),
          _vm._v(" "),
          _vm.inquireAnonymousModalIsOpen
            ? _c("AnonymousInquiryModal", {
                on: {
                  "hide-modal": function ($event) {
                    _vm.inquireAnonymousModalIsOpen = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }